import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'checkbox-component',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() public state: boolean;
  @Input() public label: string;
  @Input() public disabled: boolean;
  @Input() public color: string;
  @Output() public onChange: EventEmitter<boolean>;

  constructor() {
    this.state = false;
    this.label = '';
    this.disabled = false;
    this.onChange = new EventEmitter<boolean>();
  }

  onClick() {
    if (!this.disabled) {
      this.state = !this.state;
      this.onChange.emit(this.state);
    }
  }
}
